import { z } from 'zod';

export const DataSetReference = z
  .object({
    dataSetId: z.string(),
    dataSetVersion: z.string(),
  })
  .describe('DataSetReference');

export type DataSetReference = z.infer<typeof DataSetReference>;

export const TaggedDataSetReference = z.object({
  automationTag: z.string(),
  dataSetReference: DataSetReference,
});

export type TaggedDataSetReference = z.infer<typeof TaggedDataSetReference>;
